import { Box, styled } from "@mui/material";
import { TObjectFit } from "./MediaItem";

interface IStyledMediaItemBox {
  borderColor?: string;
  borderOnHoverColor?: string;
}

export const StyledMediaItemBox = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "borderOnHoverColor" && prop !== "borderColor",
})<IStyledMediaItemBox>`
  position: relative;
  overflow: hidden;

  ${(props) =>
    props.borderColor && `box-shadow: 0 0 0 1px ${props.borderColor};`}

  ${(props) =>
    props.borderOnHoverColor &&
    `&:hover {
      box-shadow: 0 0 0 1px ${props.borderOnHoverColor};
    }`}
`;

export const StyledMediaItemContainer = styled("div")`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  > img {
    width: 100%;
    height: 100%;
  }
`;

interface IStyledImage {
  objectFit: TObjectFit;
}

export const StyledImage = styled("img")<IStyledImage>`
  object-fit: ${(props) => props.objectFit};
`;
